import 'reset.scss/reset.scss'

import './scss/style.scss'

import 'particles.js';
import particlesConfig from './js/particles-config.json';

window.addEventListener('DOMContentLoaded', () => {
  particlesJS('particles', particlesConfig);
});
